import s from './select-participant.module.scss'
import { Dropdown } from '@shared/ui/dropdown/dropdown'
import { useProfile } from '@shared/api/useProfile'
import { useActiveProfileInfo } from '@entities/profile/lib/use-active-profile-info'
import { getAvatarUrl } from '@utils/lib/getAvatarUrl'

const avatarUrl = getAvatarUrl

// Выбор участника занятия (постановка «Родители и дети»):
// владелец аккаунта бронирует занятие для себя или для детского профиля.
// value: null — владелец аккаунта, иначе id детского профиля.
export const SelectParticipant = ({ value, onChange }) => {
	const { data: account } = useProfile()
	const { profiles } = useActiveProfileInfo()

	if (!profiles.length) {
		return null
	}

	const options = [
		{ id: null, label: `${account?.name} (я)`, image: avatarUrl(account?.avatar) },
		...profiles.map((profile) => ({
			id: profile.id,
			label: profile.name,
			image: avatarUrl(profile.avatar),
		})),
	]

	const selected = options.find((option) => option.id === value) ?? options[0]

	return (
		<Dropdown
			className={s.selectWrapper}
			label="Кто занимается"
			options={options}
			value={selected.label}
			onChange={(option) => onChange(option?.id ?? null)}
		/>
	)
}
